export function openHelpDrawer(section: string) {
  window.dispatchEvent(
    new CustomEvent('help:open', { detail: { section } })
  )
}
